export default `${process.env.REACT_APP_BASE_IMAGE_URL}`;
